import React from "react";
 import { useParams } from "react-router-dom";
import StablePrime from "../Tables/StablePrime";



function QcReportStableMrpl({ setPageHeader }) {
  const { docNo } = useParams();
  setPageHeader("Audit Record");
  // return (
  //   <div>
  //     <StablePrime editSingleColumn={true} url="/qc/auditrecord" data={{sessid :docNo}} identity="perfparam" />
  //   </div>
  // );

  return (
    <>
      (
        <StablePrime editSingleColumn={true} zenTable={true} url="/qc/auditrecord" data={{sessid :docNo}}identity="DataTable" />
      ) : (
        <></>
      )
    </>
  );



}

export default QcReportStableMrpl;
